import React from "react";
import { Platform, Pressable } from "react-native";
import { FormState, types } from "./SkipBags.validation";
import { SKIPBAGS_TYPES } from "lib/constants/skipBagTypes";
import placeholderImage from "lib/images/skip-bag.png";
import { FlexGrid, Heading, Panel } from "@clearabee/ui-library-native";
import { Image } from "components/Image/Image";
import { styles, ids } from "./SkipBags.styles";
import { useCatalogue } from "@clearabee/ui-sdk";
import { useQuestionContext } from "lib/providers/questionProvider";
import { useTranslation } from "react-i18next";

export const SelectType = (): React.ReactElement => {
  const { defaultCatalogue } = useCatalogue();
  const context = useQuestionContext<FormState>();
  const [translate] = useTranslation();

  const getTitle = (sku: typeof types[number]) => {
    if (sku === "BAGCOLLECTIONSKIPBAGS")
      return translate(
        "hwa.components.skipBags.steps.selectTypes.bookAndCollection",
      );
    if (sku === "BAGONLYSKIPBAGS")
      return translate("hwa.components.skipBags.steps.selectTypes.bagOnly");
    if (sku === "COLLECTIONONLYSKIPBAGS")
      return translate(
        "hwa.components.skipBags.steps.selectTypes.collectionOnly",
      );
  };

  const skipBagsTypes = defaultCatalogue.items.filter((i) =>
    Object.keys(SKIPBAGS_TYPES).includes(i.sku),
  );

  const handlePress = (sku: typeof types[number]) => () => {
    (context.get("type") !== sku
      ? context.reset({ type: sku })
      : context.set("type", sku)
    ).open(sku === "COLLECTIONONLYSKIPBAGS" ? "isPaid" : "products");
  };

  return (
    <FlexGrid
      style={styles.gridMarginTop}
      cellSpacing="xsmall"
      rowSpacing="xsmall"
    >
      {skipBagsTypes.map(({ sku, img }) => {
        return (
          <FlexGrid.Cell key={sku} base="100%" small="50%" large="33.33%">
            <Pressable onPress={handlePress(sku as typeof types[number])}>
              <Panel
                styles={styles.selectTypePanel}
                shadow={Platform.OS === "web"}
              >
                <Image
                  source={img ?? placeholderImage}
                  style={styles.selectTypeImage}
                />
                <Heading
                  styles={styles.selectTypeHeading}
                  dataSet={{ ids: ids.selectTypeHeading }}
                  color="brand"
                  level={5}
                >
                  {getTitle(sku as typeof types[number])}
                </Heading>
              </Panel>
            </Pressable>
          </FlexGrid.Cell>
        );
      })}
    </FlexGrid>
  );
};
